import { FC, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { useSearchParams } from "react-router-dom";
import { Tabs, TabsList, TabsTrigger } from "~/components/ui/tabs";
import { useTrackPageVisit } from "~/hooks/useTrackPageVisit";
import { ArchivedCasesList } from "./archived-cases/ArchivedCasesList";
import { ArchivedDocumentsList } from "./archived-docs/ArchivedDocumentsList";

enum ArchivedTab {
  Cases = "cases",
  Documents = "documents",
}

export const SettingsArchived: FC = () => {
  useTrackPageVisit("app/settings_archived/visit");

  const [searchParams, setSearchParams] = useSearchParams();
  const currentTab = searchParams.get("tab") as ArchivedTab;

  useEffect(() => {
    if (!currentTab) {
      setSearchParams({ tab: ArchivedTab.Cases });
    }
  }, [currentTab, setSearchParams]);

  const onTabChange = (value: string) => {
    setSearchParams({ tab: value });
  };

  return (
    <div className="flex flex-col gap-6 mt-2 w-full">
      <h3 className="text-2xl font-semibold">
        <FormattedMessage
          id="settings.archivedCases"
          defaultMessage={"Archive"}
        />
      </h3>
      <div className="flex flex-col justify-between gap-2">
        <Tabs
          defaultValue={currentTab || ArchivedTab.Cases}
          onValueChange={onTabChange}
        >
          <TabsList>
            <TabsTrigger value={ArchivedTab.Cases}>
              <FormattedMessage id="cases" />
            </TabsTrigger>
            <TabsTrigger value={ArchivedTab.Documents}>
              <FormattedMessage id="documents" />
            </TabsTrigger>
          </TabsList>
        </Tabs>
        {currentTab === ArchivedTab.Cases && <ArchivedCasesList />}
        {currentTab === ArchivedTab.Documents && <ArchivedDocumentsList />}
      </div>
    </div>
  );
};
